import { Button, Icon, ICONS_ENUM } from '@sanlam-glacier/app-common/components';
import { useState } from 'react';
import { Regulation28ExposureModal } from '../../molecules/reg28-exposure-breakdown-takeover/Regulation28ExposureModal';
import styles from './view-full-breakdown-button.module.scss';
import {
  Reg28ExposureBreachModelMock,
  Reg28ExposureBreakdownModelMock
} from '../../../types/regulation-28/regulation-28.interfaces';

type ViewFullBreakdownButtonProps = {
  clientName: string;
  exposureBreaches: Reg28ExposureBreachModelMock[];
  exposureBreakdown: Reg28ExposureBreakdownModelMock;
  buttonText: string;
};

export const ViewFullBreakdownButton = ({
  clientName,
  exposureBreaches,
  exposureBreakdown,
  buttonText
}: ViewFullBreakdownButtonProps) => {
  const testComponentName = 'regulation28';

  const [isExposureBreakdownModalOpen, setExposureBreakdownModalOpen] = useState(false);
  return (
    <>
      <Button
        data-testid={`${testComponentName}ViewFullBreakdownButton`}
        className={styles.viewFullBreakdownButton}
        onClick={() => {
          setExposureBreakdownModalOpen(true);
        }}
        startIcon={<Icon icon={ICONS_ENUM.ACTION_VISIBILITY} />}
        variant={Button.VARIANT.TERTIARY}
        size={Button.SIZE.SMALL}
      >
        {buttonText}
      </Button>
      <div className={styles.regulation28ExposureModalWrapper}>
        <Regulation28ExposureModal
          isOpen={isExposureBreakdownModalOpen}
          onClose={() => setExposureBreakdownModalOpen(false)}
          clientName={clientName}
          breaches={exposureBreaches}
          exposureBreakdown={exposureBreakdown}
        />
      </div>
    </>
  );
};
